import cn from "classnames"

import { PriceAndDiscount } from "./components/PriceAndDiscount"
import style from "./style.module.scss"

import { Psychologist } from "utils/interfaces"
import { getPublicServices } from "utils/helpers/psychologistUtil"

interface Props {
    psy: Psychologist
    hasBorderTop?: boolean
}

export const Price = ({ psy, hasBorderTop = true }: Props) => {
    const publicServices = getPublicServices(psy.offered_services)
    if (!publicServices.length) return null
    return (
        <div className={cn(style.container, { [style.noBorderTop]: !hasBorderTop })}>
            <div className={style.content}>
                <PriceAndDiscount psy={psy} />
            </div>
        </div>
    )
}
